import { createContext } from 'react';
import { B2BContextType } from './AuthContex/B2BAuthContext';
import { ExhibitorContextType } from './AuthContex/ExhibitorAuthContext';
export const B2BContext = createContext<B2BContextType | undefined>(undefined);
export const ExhibitorContext = createContext<ExhibitorContextType | undefined>(
  undefined
);
